export enum RewardType {
  Badge = "BADGE",
  Points = "POINTS",
  PrizeDrawEntry = "PRIZE_DRAW_ENTRY",
  Reward = "SALES_REWARD",
  DealRegistrationReward = "DEAL_REGISTRATION_REWARD",
  Voucher = "VOUCHER",
  Experience = "EXPERIENCE",
  OpportunityReward = "OPPORTUNITY_REWARD",
}